import './hierarchy_pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.DonutPieChartView extends Monitoring.Views.Charts.HierarchyPieChartView

  afterAppend: ->
    if @data
      @firstRender = false
      super
    else
      @ajaxCall(@url, @searchQuery.toJSON(), (response) =>
        @data = response
        @firstRender = true
        super
      )
    return this

  _dataIsEmpty: ->
    if @data? and @data.levels? and @data.levels.length > 0
      arr = @data.levels[0]
      sum = 0
      for i in [0...arr.length]
        sum += arr[i].y
      return sum == 0
    return true

  _tooltipFormatter: () ->
    if @key
      value = @y
      name = @key
      if name.substr(name.length-2, name.length) == "%)"
        name = name.substr(0, @key.length - 8)
        @point.name = name
      "<b>#{name}</b><br/>Cantidad: #{value} (#{Math.round(@percentage * 10) / 10}%)"
    else
      false


  _series: ->
    @_setDataColors()
    series = []
    levels = @_getLevels()
    length = levels.length

    @firstRender = false if @firstRender

    for i in [length-1..0]
      series.push({
        data: levels[i]
        size: "#{100*(i+1)/length}%"
        showInLegend: i==0
        point:
          events:
            click: @_pieClick
      })
    series

  _setDataColors: =>
    levels = @_getLevels()
    for i in [0...levels.length]
      level = levels[i]
      for j in [0...level.length]
        obj = level[j]
        if obj.hidden or obj.y == 0
          obj.color = "rgba(0,0,0,0)"
        else
          obj.color = @_colorWithDepth obj.main_branch, obj.level, levels.length
          obj.borderColor = "#DDD"

  _getLevels: ->
    if @showAllLevels then @_formattedLevels() else [@_formattedLevels()[0]]

  _formattedLevels: ->
    @data.levels

  _colorWithDepth: (name, level, maxLevel) ->
    color = @_getColor name
    degradeAlphaPercentage = 0.9 / (maxLevel || 4)
    color[3] = 1 # alpha value
    color[3] -= degradeAlphaPercentage*(level-1) # same as boxes's pie_tree
    color[3] = Math.max(0, color[3])
    "rgba(#{color[0]},#{color[1]},#{color[2]},#{color[3]})"

  _getColor: (name) ->
    colors = [
      "3949AB",
      "FB8C00",
      "D81B60",
      "FDD835",
      "039BE5",
      "E53935",
      "00897B",
      "8E24AA",
      "757575",
      "7CB342",
      "9FA8DA",
      "FFCC80",
      "F48FB1",
      "FFF59D",
      "81D4FA",
      "EF9A9A",
      "80CBC4",
      "CE93D8",
      "EEEEEE",
      "C5E1A5",
      "5C6BC0",
      "FFA726",
      "EC407A",
      "FFEE58",
      "29B6F6",
      "EF5350",
      "26A69A",
      "BDBDBD",
      "9CCC65",
      "AB47BC"]
    @nextColor ||= 0
    @map ||= {}
    if @map[name]
      color = @map[name].slice(0)
    else
      color = colors[@nextColor]
      @map[name] = colors[@nextColor].slice(0)
      @nextColor = (@nextColor+1) % colors.length
    colorR = color.substr(0,2)
    colorG = color.substr(2,2)
    colorB = color.substr(4,2)
    [
      parseInt(colorR, 16),
      parseInt(colorG, 16),
      parseInt(colorB, 16),
    ]

  customOptions: =>
    showAllLevelsText = if @showAllLevels
      I18n.t('monitoring.dashboard.charts.one_level')
    else
      I18n.t('monitoring.dashboard.charts.all_levels')
    [
      {
        text: showAllLevelsText
        onclick: =>
          @showAllLevels = !@showAllLevels
          @afterAppend()
      }
    ]
